export const defaultNames = [
  'Amara',
  'Beatriz',
  'Caleb',
  'Dilara',
  'Emeka',
  'Freya',
  'Gustavo',
  'Hana',
  'Ivan',
  'Jolene',
]
